import { computeCosts } from "@/utils/costUtil";

export default function CostSummary({ images = [], videos = [], pricing, isFeatured, featuredPaid, t, includedImages, includedVideos }) {

	const cost = computeCosts(images, videos, pricing, isFeatured, featuredPaid, includedImages, includedVideos);

	return (
		<div className="bg-white border border-[#E6E2D6] rounded-sm p-6" data-testid="cost-summary">
			<h2
				className="text-lg font-semibold text-[#1A3C34] font-['Playfair_Display'] mb-4">{ t('horse.cost_summary') }</h2>
			<div className="space-y-2 text-sm">
				<div className="flex justify-between text-[#666055]">
					<span>{ t('horse.images_section') } ({ cost.enabledImages.length }/{ cost.freeImgLimit } { t('horse.included') })</span>
					<span data-testid="cost-images">{ cost.extraImages > 0 ? `${ cost.imgCostNoVat } EUR` : t('horse.free') }</span>
				</div>
				{ cost.extraImages > 0 && (
					<div className="flex justify-between text-[#8B4513] text-xs pl-4">
						<span>{ t('horse.extra_images_cost', { count: cost.extraImages }) }</span>
						<span>{ cost.extraImages } x { cost.pricingExtraImageNoVat } EUR</span>
					</div>
				) }
				<div className="flex justify-between text-[#666055]">
					<span>{ t('horse.video_section') } ({ cost.enabledVideos.length }/{ cost.freeVidLimit } { t('horse.included') })</span>
					<span data-testid="cost-videos">{ cost.extraVideos > 0 ? `${ cost.vidCostNoVat } EUR` : t('horse.free') }</span>
				</div>
				{ cost.extraVideos > 0 && (
					<div className="flex justify-between text-[#8B4513] text-xs pl-4">
						<span>{ t('horse.extra_videos_cost', { count: cost.extraVideos }) }</span>
						<span>{ cost.extraVideos } x { cost.pricingExtraVideoNoVat } EUR</span>
					</div>
				) }
				<div className="flex justify-between text-[#666055]">
					<span>{ t('horse.featured_cost') }</span>
					<span data-testid="cost-featured">{ isFeatured ? `${ cost.featCostNoVat } EUR` : '—' }</span>
				</div>
				<div className="flex justify-between text-[#666055]">
					<span>{ t('admin.vat_percent') } ({ cost.vatPercentage } %) </span>
					<span data-testid="cost-featured">{ cost.vatAmount > 0 ? `${ cost.vatAmount } EUR` : '—' }</span>
				</div>
				<div className="border-t border-[#E6E2D6] pt-3 mt-3 flex justify-between font-bold text-base">
					<span className="text-[#1A3C34]">{ t('horse.total_cost') }</span>
					<span className="text-[#8B4513] text-lg" data-testid="cost-total">{ cost.total.toFixed(2) } EUR</span>
				</div>
				{ cost.total === 0 && <p className="text-center text-xs text-[#666055] mt-1">{ t('horse.free') }</p> }
			</div>
		</div>
	)
}
